<div class="created-by-container">
  <cc-user-avatar [user]="field.createdByWeb"></cc-user-avatar>
  <strong class="user-name">{{ field.createdByWeb?.fullName }}</strong>
</div>
